// Google Analytics 4 Integration
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initializeAnalytics = () => {
  // Analytics is optional. Do not send requests with a placeholder identifier.
  if (!GA_MEASUREMENT_ID || window.gtag) return;

  // Load Google Analytics script
  const script = document.createElement('script');
  script.id = 'gpj-google-analytics';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
  
  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    page_title: 'Good Parents Justice',
    page_location: window.location.href,
    send_page_view: true
  });
  
  // Make gtag available globally
  window.gtag = gtag;
};

// Custom event tracking for legal platform
export const trackEvent = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      event_category: 'Family Law Platform',
      event_label: parameters.label || '',
      value: parameters.value || 0,
      ...parameters
    });
  }
};

// Specific tracking functions for your platform
export const trackFormStart = (formType) => {
  trackEvent('form_start', {
    event_category: 'Legal Forms',
    event_label: formType,
    form_type: formType
  });
};

export const trackFormComplete = (formType) => {
  trackEvent('form_complete', {
    event_category: 'Legal Forms',
    event_label: formType,
    form_type: formType,
    value: 1
  });
};

export const trackResourceView = (resourceType, resourceTitle) => {
  trackEvent('resource_view', {
    event_category: 'Legal Resources',
    event_label: resourceTitle,
    resource_type: resourceType
  });
};

export const trackVideoWatch = (videoTitle, duration) => {
  trackEvent('video_play', {
    event_category: 'Video Tutorials',
    event_label: videoTitle,
    video_title: videoTitle,
    value: duration
  });
};

export const trackCalendarEvent = (eventType) => {
  trackEvent('calendar_event_created', {
    event_category: 'Calendar',
    event_label: eventType,
    event_type: eventType
  });
};

export const trackUserRegistration = () => {
  trackEvent('sign_up', {
    event_category: 'User Account',
    method: 'email'
  });
};

export const trackUserLogin = () => {
  trackEvent('login', {
    event_category: 'User Account',
    method: 'email'
  });
};

// Page view tracking
export const trackPageView = (pageName, pageTitle) => {
  if (GA_MEASUREMENT_ID && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: pageTitle,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }
};

// User engagement tracking
export const trackEngagement = (engagementType, value) => {
  trackEvent('engagement', {
    event_category: 'User Engagement',
    event_label: engagementType,
    engagement_type: engagementType,
    value: value
  });
};

// Legal disclaimer acceptance tracking
export const trackDisclaimerAcceptance = () => {
  trackEvent('disclaimer_accepted', {
    event_category: 'Legal Compliance',
    event_label: 'Terms Accepted'
  });
};

// Search tracking
export const trackSearch = (searchTerm, resultsCount) => {
  trackEvent('search', {
    event_category: 'Site Search',
    event_label: searchTerm,
    search_term: searchTerm,
    value: resultsCount
  });
};
